module.exports = __webpack_public_path__ + "static/media/background_login.2cad5062.jpg";